/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, memo } from 'react';
import classNames from 'classnames';
import './Modal.scss';

type Tabs = { label: string }

interface Props {
    children?: React.ReactNode[],
    customClassName?: string,
    showModal?: boolean,
    onClose?: ((event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void) | undefined,
    isCloseHidden?: boolean,
    tabs?: Tabs[],
}

const Modal: React.FC<Props> = ({
  children,
  customClassName = '',
  showModal = true,
  onClose = () => {},
  isCloseHidden = false,
  tabs = [{
    label: 'Update Application Status',
  }, {
    label: 'Applicant’s Timestamps',
  }],
}): JSX.Element => {
  const [selectedTab, setTab] = useState(0);

  const tabsSelect = (e: number) => {
    setTab(e);
  };

  const classes = classNames({
    modal: true,
  });

  const close = (e) => {
    setTab(0);
    onClose(e);
  };

  if (showModal) {
    return (
      <div className="layout modal-overlay">
        <section className={`${classes} ${customClassName}`}>
          {!isCloseHidden && <span className="modal__close" onClick={close} />}
          <header className="modal__header">
            <ul>
              {tabs.map((item, idx) => (
                <li
                  className={idx === selectedTab ? 'modal__header--active' : ''}
                  key={idx}
                  onClick={() => tabsSelect(idx)}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </header>
          <div className="modal__content">
            {children?.map((child, idx) => (idx === selectedTab
              ? <React.Fragment key={idx}>{child}</React.Fragment>
              : <React.Fragment key={idx} />))}
          </div>
        </section>
      </div>
    );
  }
  return <></>;
};

export default memo(Modal);
